import { type ReactElement } from 'react'
import * as S from './house.styled'
import image from './assets/image.png'
import { LinkButton } from '../button/link-button'

export function House (): ReactElement {
  return <S.Container>
    <S.Content>
      <S.TextContainer>
        <S.TextContent>
          <h1>Sua casa dos sonhos pode virar realidade</h1>
          <p>
            <strong>Já pensou em conquistar uma casa no valor de R$200.000? Com o Cartão de TODOS Sonhos, isso pode acontecer!</strong>
            <br />
            <br />
            Todo mês, uma nova casa é sorteada.
            É mais do que um prêmio. É a chance de mudar de vida.
          </p>
        </S.TextContent>
        <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Quero a casa dos sonhos!</LinkButton>
      </S.TextContainer>
      <figure>
        <img src={image} alt="" />
        <figcaption>Imagem meramente ilustrativa</figcaption>
      </figure>
    </S.Content>
  </S.Container>
}
